import { FC, HTMLAttributes, useEffect } from "react";
import { useStyles } from "./EssentialPack.style";
import { useGamepadContext } from "../../contexts/GamepadProvider";
import { onGameListMoveAction } from "../../models/gamepad";
import { HeroBanner } from "../../components/common/HeroBanner";
import { useQuery } from "@apollo/client";
import { pageGQL, Query } from "@onmo/graphql/graphql";
import { GameCategory } from "../../components/common/GameCategory";
import map from "lodash-es/map";
import { isTV } from "../../utils/platform";
import { getMediaSizeScale } from "../../models/screen";

const EssentialPack: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const classes = useStyles();
  const { setCallback, cleanup } = useGamepadContext();
  const { data: pageData } = useQuery<Query>(pageGQL, {
    variables: { input: { page: "essential" } },
  });

  const defaultCardWidth = isTV
    ? 320 * getMediaSizeScale()
    : undefined;

  useEffect(() => {
    setCallback({
      onMoveAction: onGameListMoveAction,
    });

    return () => {
      cleanup();
    };
  }, [cleanup, setCallback]);

  return (
    <div className={classes.root}>
      <div className={classes.rootContent} id="essential-pack">
        <HeroBanner type="essentialPack" />
        <div className={classes.content}>
          {map(pageData?.page?.items, (section) => (
            <GameCategory
              key={section?.id}
              section={section}
              defaultCardWidth={defaultCardWidth}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default EssentialPack;
